import styled from 'styled-components'
import React from 'react'

const CircleLoadingStyled = styled.div`
  position: relative;
  border: 2px solid transparent;
  border-radius: 100%;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  animation: rotate 0.6s ease-in-out infinite;
  margin: 0 auto;
  @keyframes rotate {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
`
const PointLoadingStyled = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    background: #fff;
    animation: jump 0.7s ease-in-out infinite alternate;
    border-radius: 100%;
  }
  span:nth-child(2) {
    animation-delay: 0.15s;
    margin-left: 3px;
  }
  span:nth-child(3) {
    animation-delay: 0.25s;
    margin-left: 3px;
  }
  @keyframes jump {
    0% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-4px);
    }
    100% {
      transform: translateY(0);
    }
  }
`
interface LoadingProps {
  size: number
  color?: string
  stroke?: number
  classNames?: string
  type?: 'circle' | 'point'
}
const BtnLoading = ({
  type = 'circle',
  size = 30,
  color = 'var(--color-text-dark)',
  stroke = 2,
  classNames = '',
}: LoadingProps) => {
  return type === 'circle' ? (
    <CircleLoadingStyled
      className={classNames}
      style={{ width: size + 'px', height: size + 'px', borderColor: color, borderWidth: stroke }}
    />
  ) : (
    <PointLoadingStyled className={classNames}>
      <span style={{ width: size + 'px', height: size + 'px', background: color }}></span>
      <span style={{ width: size + 'px', height: size + 'px', background: color }}></span>
      <span style={{ width: size + 'px', height: size + 'px', background: color }}></span>
    </PointLoadingStyled>
  )
}

export default BtnLoading
